import { Mail, MessageCircle } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { useSite } from "@/lib/site";

export const Corporate = () => {
  const { content } = useSite();
  const s = content.settings || {};
  const number = (s.whatsapp_number || "").replace(/[^0-9]/g, "");

  return (
    <section id="corporate" data-testid="corporate-section" className="py-20 sm:py-28">
      <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
        <Reveal>
          <div className="overflow-hidden rounded-[2.5rem] bg-sagelight p-8 sm:p-14 lg:p-20">
            <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-12">
              <div className="lg:col-span-7">
                <Eyebrow>For hospitals & workplaces</Eyebrow>
                <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight text-ink">
                  Bring evidence-based lactation care to <span className="italic text-terra">your teams.</span>
                </h2>
                <p className="mt-5 max-w-xl text-base leading-relaxed text-plumsoft">
                  Corporate workshops, hospital lactation program consulting, return-to-work feeding
                  plans and employee parenting sessions — designed and delivered by Yogyata Wadhwa, IBCLC.
                </p>
              </div>
              <div className="flex flex-col gap-4 lg:col-span-5">
                <a
                  data-testid="corporate-whatsapp-btn"
                  href={`https://wa.me/${number}?text=${encodeURIComponent("Hi, we'd like to discuss a corporate workshop / hospital partnership with The Birth Life.")}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center gap-2 rounded-full bg-ink px-7 py-4 font-outfit text-sm font-semibold text-sand transition-colors duration-300 hover:bg-terra"
                >
                  <MessageCircle className="h-4 w-4" /> Enquire on WhatsApp
                </a>
                <a
                  data-testid="corporate-email-btn"
                  href={`mailto:${s.corporate_email || "birthlifeindia@gmail.com"}?subject=${encodeURIComponent("Corporate enquiry — The Birth Life")}`}
                  className="inline-flex items-center justify-center gap-2 rounded-full border border-ink/20 bg-white px-7 py-4 font-outfit text-sm font-semibold text-ink transition-colors duration-300 hover:border-terra hover:text-terra"
                >
                  <Mail className="h-4 w-4" /> {s.corporate_email || "birthlifeindia@gmail.com"}
                </a>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
